export default __webpack_public_path__ + "static/media/akar-icons_calendar.a33cadcd.svg";